import React from "react";

const SignUpIcon = (props) => {
	const BUTTON_COLOR = getComputedStyle(document.documentElement)
		.getPropertyValue("--button-color")
		.trim();
	return window.HAS_STRIPED_ICON ? (
		<svg
			width="21"
			height="22"
			viewBox="0 0 21 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.2168 12.626C4.83391 12.626 1.08984 13.317 1.08984 16.0811L1.10059 16.2617C1.316 18.0987 4.7178 20.8361 8.80566 21.0107L9.2168 21.0195C9.82568 21.0195 10.4222 20.9607 10.9981 20.8544C10.7391 20.5762 10.5058 20.2737 10.302 19.9508C9.94631 19.9956 9.58375 20.0195 9.2168 20.0195C7.2374 20.0195 5.39687 19.3321 4.05957 18.4307C3.39184 17.9805 2.87593 17.4944 2.53711 17.0469C2.1841 16.5805 2.08988 16.2463 2.08984 16.0811C2.08984 15.6415 2.2292 15.3222 2.47754 15.0537C2.74716 14.7624 3.18703 14.4884 3.83887 14.2607C5.15627 13.8006 7.04787 13.626 9.2168 13.626C9.5482 13.626 9.87291 13.6302 10.1899 13.6389C10.3926 13.291 10.6287 12.965 10.8939 12.6653C10.6119 12.6512 10.3251 12.6412 10.0342 12.6348L9.2168 12.626ZM9.2168 1.19531C11.5384 1.19557 13.5938 3.52847 13.5938 6.07813C13.5937 8.50893 11.6501 10.4539 9.2168 10.4541C6.7842 10.4541 4.83894 8.50893 4.83887 6.07813C4.83887 3.52846 6.89594 1.19531 9.2168 1.19531ZM8.93848 11.4473L9.2168 11.4541C12.1091 11.4539 14.444 9.20831 14.5869 6.35547L14.5938 6.07813C14.5938 3.18774 12.349 0.376761 9.49414 0.204102L9.2168 0.195312C6.23221 0.195312 3.83887 3.09463 3.83887 6.07813L3.8457 6.35547C3.98407 9.11644 6.17654 11.3088 8.93848 11.4473Z"
				fill={BUTTON_COLOR}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.116 20.7672C16.677 20.7672 17.1318 20.3124 17.1318 19.7514V17.7197H19.1635C19.7245 17.7197 20.1793 17.2649 20.1793 16.7039C20.1793 16.1429 19.7245 15.6881 19.1635 15.6881H17.1318V13.6564C17.1318 13.0954 16.677 12.6406 16.116 12.6406C15.555 12.6406 15.1002 13.0954 15.1002 13.6564V15.6881H13.0686C12.5075 15.6881 12.0527 16.1429 12.0527 16.7039C12.0527 17.2649 12.5075 17.7197 13.0686 17.7197H15.1002V19.7514C15.1002 20.3124 15.555 20.7672 16.116 20.7672Z"
				fill={BUTTON_COLOR}
			/>
		</svg>
	) : (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.0033 14.0258C13.4686 13.9991 12.9158 13.9872 12.3516 13.9872C8.03694 13.9872 4.35156 14.6672 4.35156 17.3882C4.35156 19.25 8.01394 22.25 12.3516 22.25C12.9513 22.25 13.5388 22.192 14.106 22.0873C13.1086 21.0159 12.4985 19.5792 12.4985 18C12.4985 16.4757 13.0669 15.0842 14.0033 14.0258ZM17.6455 7.54105C17.6455 4.60402 15.2907 1.75 12.3516 1.75C9.41346 1.75 7.05758 4.60402 7.05758 7.54105C7.05758 10.4781 9.41346 12.8331 12.3516 12.8331C15.2907 12.8331 17.6455 10.4781 17.6455 7.54105Z"
				fill={BUTTON_COLOR}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.1484 22C19.7007 22 20.1484 21.5523 20.1484 21V19H22.1484C22.7007 19 23.1484 18.5523 23.1484 18C23.1484 17.4477 22.7007 17 22.1484 17H20.1484V15C20.1484 14.4477 19.7007 14 19.1484 14C18.5962 14 18.1484 14.4477 18.1484 15V17H16.1484C15.5962 17 15.1484 17.4477 15.1484 18C15.1484 18.5523 15.5962 19 16.1484 19H18.1484V21C18.1484 21.5523 18.5962 22 19.1484 22Z"
				fill={BUTTON_COLOR}
			/>
		</svg>
	);
};

export default SignUpIcon;
